import React, { useState } from "react";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import { useForm } from "react-hook-form";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import PropTypes from "prop-types";

const Relationship = (props) => {
  const { endrelationship } = props;
  const { register, formState: { errors }, handleSubmit } = useForm();
  const history = useNavigate();
  const [loader, setLoader] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const onSubmit = (data) => {
    const request = {};
    request.mentee_id = endrelationship.mentee_id;
    request.mentor_id = endrelationship.mentor_id;
    request.status = endrelationship.status;
    request.actionid = endrelationship.actionid;
    setLoader(true)
    request.reason = data.reason;
    agent
      .post(API.ASSIGN_MENTOR_REQUEST, request)
      .then((res) => {
        setPopupMessage(res?.data?.message);
        setShowPopup(true);
      })
      .catch((err) => {
        console.error(err);
        setLoader(false)
      });
  };

  const handleRelationshipPopupClose = () => {
    setShowPopup(false);
    setLoader(false);
    props.onHide(); // close modal
    history("/mentees-request"); // navigate after OK click
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered className="calendar-modal"
      >
        <Modal.Header closeButton>Reason*</Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="mentor_detail align-items-center">
              <Col sm={12}>
                <Form.Control
                  as="textarea"
                  className={
                    errors.reason ? "form-control is-invalid" : "form-control"
                  }
                  name="reason"
                  defaultValue={endrelationship.reason}
                  aria-invalid={errors.reason ? "true" : "false"}
                  {...register("reason", {
                    required: {
                      value: true,
                      message: "Please enter reason",
                    },
                    validate: (value) => {
                      if (value.trim() == "") {
                        return "Please enter reason";
                      } else {
                        return true;
                      }
                    },
                  })}
                />
                {/* {errors?.reason &&  */}
                {errors?.reason?.message && (
                  <label className="customeValidationText text-left">
                    {errors?.reason?.message}
                  </label>
                )}
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <div className="form-group mt-3 text-left">
                  <Button
                    className="btn loginsubmit nextbtn ml-2"
                    type="submit"
                    disabled={loader}
                  >
                    {loader ? 'Submitting...' : 'Submit'}
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
      <PopupModalWithOk
        show={showPopup}
        onHide={handleRelationshipPopupClose}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />
    </>
  );
};

Relationship.propTypes = {
  endrelationship: PropTypes.shape({
    mentee_id: PropTypes.number.isRequired,
    mentor_id: PropTypes.number.isRequired,
    status: PropTypes.number.isRequired,
    actionid: PropTypes.number.isRequired,
    reason: PropTypes.string,
  }).isRequired,
  onHide: PropTypes.func.isRequired,
};

export default Relationship;
